module.exports = __webpack_public_path__ + "static/media/sneks.7cf4c5f6.png";